import React from "react";
import { HorizontalEllipsisIcon } from "assets/icons";
import { ConfigProvider, Tabs } from "antd";
const { TabPane } = Tabs;

const CustomTabs = ({ tabs, activeKey, onChange }) => {
  return (
    <div className="[&_.ant-tabs-nav-operations]:!pl-0 [&_.ant-tabs-nav-operations>button]:!ml-0">
      <ConfigProvider
        theme={{
          components: {
            Tabs: {
              itemActiveColor: "#fab54e",
              inkBarColor: "#fab54e",
              itemColor: "white",
              itemSelectedColor: "#fab54e",
              itemHoverColor: "#fab54e",
            },
          },
        }}
      >
        <Tabs
          activeKey={activeKey}
          onChange={onChange}
          style={{ height: "100%" }}
          tabBarStyle={{
            backgroundColor: "#1996a6",
            paddingLeft: 25,
            position: "unset",
          }}
          tabBarGutter={40}
          moreIcon={
            <div className="text-white">
              <HorizontalEllipsisIcon />
            </div>
          }
        >
          {tabs?.map((tab) => (
            <TabPane tab={tab?.label} key={tab?.key}>
              {tab?.content}
            </TabPane>
          ))}
        </Tabs>
      </ConfigProvider>
    </div>
  );
};

export default CustomTabs;
